import { render, staticRenderFns } from "./FolderSelector.vue?vue&type=template&id=4d88bd55&scoped=true"
import script from "./FolderSelector.vue?vue&type=script&lang=js"
export * from "./FolderSelector.vue?vue&type=script&lang=js"
import style0 from "./FolderSelector.vue?vue&type=style&index=0&id=4d88bd55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88bd55",
  null
  
)

export default component.exports